import { TIER_DISPLAY } from '../utils/conditionScoring'

// Display-only severity readout for the matrix review screen — field tool and
// StoneQA both show it via stoneMatrix.severity (see useStoneMatrix.initMatrix
// / conditionScoring.js). Not persisted yet (Decision 11, Phase 1) — this is
// purely so a reviewer can see the number while field-testing/calibrating,
// ahead of the Phase 2 migration that would store it and put it on the map.
export default function SeverityBadge({ severity }) {
  if (!severity) return null
  const tier = TIER_DISPLAY[severity.tier]
  return (
    <div className="mt-2 flex items-center gap-2 flex-wrap">
      {tier && (
        <span
          className="text-xs font-bold px-2 py-1 rounded"
          style={{ backgroundColor: tier.bg, color: tier.text }}
        >
          Severity {severity.severityScore}/100 · {tier.label}
        </span>
      )}
      {severity.material && severity.material !== 'unknown' && (
        <span className="text-xs text-gray-400 capitalize">{severity.material}</span>
      )}
      {severity.treatmentFlag && (
        <span className="text-xs font-bold px-2 py-1 rounded bg-red-950 text-red-300 border border-red-700">
          DO NOT SCRUB
        </span>
      )}
    </div>
  )
}
